// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pspHeader.MuiTypography-root {
  color: #0d1021;
  text-align: center;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  padding-left: 5px;
}

.pspSubHeader.MuiTypography-root {
  color: var(--Neutral-8, #595959);
  text-align: center;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-left: 25px;
  display: flex;
  justify-content: flex-start;
}

.cardSize {
  height: 60px;
  padding: 8px !important;
  margin-right: 20px;
  border: 3px !important;
  width: 200px;
  display: flex;
  justify-content: center;
}

.cardTitle.MuiTypography-root {
  color: #0d1021;
  text-align: center;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 142px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-top: 12px;
}

.categoryHeader {
  width: 100%;
  display: flex;
  justify-content: space-between;
  height: 60px;
  padding: 14px 8px;
  align-items: baseline;
}

.previewHeader {
  border: 1px solid rgb(222, 222, 230);
  border-radius: 12px;
  padding: 0px 10px 10px;
  width: 99%;
}

.methodsHeader {
  display: flex;
  flex-wrap: wrap;
  border-color: #0101021f;
  padding: 2px 10px 2px;
  margin-top: 6px;
  margin-bottom: -12px;
}

.gatewayHeading.MuiTypography-root {
  text-align: center;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.alertText.MuiTypography-root {
  color: #0d1021;
  font-family: Poppins;
  font-size: 12px;
  padding-left: 5px;
  padding-right: -10px;
}

.previewHeading.MuiTypography-root {
  color: var(--Text-High, rgba(1, 1, 2, 0.72));
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/Configurations/Payment Gateways/gatewayStyle.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,4CAA4C;EAC5C,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".pspHeader.MuiTypography-root {\n  color: #0d1021;\n  text-align: center;\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n  padding-left: 5px;\n}\n\n.pspSubHeader.MuiTypography-root {\n  color: var(--Neutral-8, #595959);\n  text-align: center;\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  margin-left: 25px;\n  display: flex;\n  justify-content: flex-start;\n}\n\n.cardSize {\n  height: 60px;\n  padding: 8px !important;\n  margin-right: 20px;\n  border: 3px !important;\n  width: 200px;\n  display: flex;\n  justify-content: center;\n}\n\n.cardTitle.MuiTypography-root {\n  color: #0d1021;\n  text-align: center;\n  font-family: Poppins;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  max-width: 142px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-top: 12px;\n}\n\n.categoryHeader {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  height: 60px;\n  padding: 14px 8px;\n  align-items: baseline;\n}\n\n.previewHeader {\n  border: 1px solid rgb(222, 222, 230);\n  border-radius: 12px;\n  padding: 0px 10px 10px;\n  width: 99%;\n}\n\n.methodsHeader {\n  display: flex;\n  flex-wrap: wrap;\n  border-color: #0101021f;\n  padding: 2px 10px 2px;\n  margin-top: 6px;\n  margin-bottom: -12px;\n}\n\n.gatewayHeading.MuiTypography-root {\n  text-align: center;\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n}\n\n.alertText.MuiTypography-root {\n  color: #0d1021;\n  font-family: Poppins;\n  font-size: 12px;\n  padding-left: 5px;\n  padding-right: -10px;\n}\n\n.previewHeading.MuiTypography-root {\n  color: var(--Text-High, rgba(1, 1, 2, 0.72));\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
